import { render, staticRenderFns } from "./AmbassadorInvitation.vue?vue&type=template&id=4722ec8d&"
import script from "./AmbassadorInvitation.vue?vue&type=script&lang=js&"
export * from "./AmbassadorInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports